import React from "react";

export const UploadInputInterface = ({ file, onFileChange }) => {
  return (
    <div className="relative">
      <input
        id="document"
        name="document"
        type="file"
        onChange={onFileChange}
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
      />
      <div className="w-full px-3 py-2 border border-gray-300 rounded-md bg-white flex justify-end items-center">
        <span className="mr-6">
          {file ? file.name : "هیچ فایلی انتخاب نشده"}
        </span>
        <button
          type="button"
          className="px-4 py-2 bg-blue-50 text-primary rounded-md hover:bg-blue-100"
        >
          انتخاب فایل
        </button>
      </div>
    </div>
  );
};
